import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Button } from '@progress/kendo-react-buttons';

import { displayDrawerMenu } from './navigation.actions';
import MakrwatchLogo from '../../common/components/makrwatchLogo';

const MobileMenuComponent = (props) => {

    const handleClick = () => {
        props.onButtontTap(true);
    };

    return (
        <Fragment>
            <div className="mobile-menu-button-container">
                <Button icon="menu" look="flat" onClick={handleClick}/>
            </div>
            <div className="mobile-menu-logo-container">
                <MakrwatchLogo />
            </div>
        </Fragment>
    );
};

const mapDispatchToProps = (dispatch) => {
    const props = {
        onButtontTap: (visible) => dispatch(displayDrawerMenu(visible))
    };
    return props;
};

const MobileMenu = connect(null, mapDispatchToProps)(MobileMenuComponent);

export default MobileMenu;
